import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom"; // useHistory와 useLocation 추가
import { Stack, Box, Typography } from "@mui/material";
import TitleBox from '../CommonComponent/TitleBox';
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";
import { Add as AddIcon } from "@mui/icons-material";
import { usePenStatus } from "../../nativebridge/PenStatus";
import { Icon } from '@iconify/react';
import { ContentsBox, ListBox, StyledLinkButton } from "./Styled/SettingStyled";
import PokoroConnectLoading from "./PokoroConnectLoading";
import UnpokoroSetting from "@/common/Images/UnPokoroSetting.svg"
import CommonButton from "@/views/CommonComponent/CommonButton";
import { useToast } from '../../components/useToast';
import { c } from "../../theme/colorUtils";
import { COMMON_UTIL } from "@/common/util/common.util";
import {
  connectPokoro,
  stopScan,
  disConnectPokoro,
  customSendToken,
  customSendSetting,
} from "../../nativebridge/JsToNative";


import {
  NativeToJsBridge,
  NativeToJsEventName,
  NativeToJsEventOnDeviceDisconnected,
  NativeToJsEventOnDeviceConnected,
  NativeToJsEventOnDeviceConnectFail,
} from "../../nativebridge/NativeToJs";



export const languageMap = {
  US: "English",
  KR: "한국어",
  JP: "日本語",
  CN: "简体中文",
  ES: "Español",
  DE: "Deutsch",
  XA: "ٱلسُّعُوْدِيَّة",
};

function PokoroSetting(props) {
  const history = useHistory();
  const location = useLocation(); // 현재 위치 정보 가져오기
  const { intl, languageStore, userStore, authStore } = props;
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  // const [loading, setLoading] = React.useState(false);
  const [showConnectLoading, setShowConnectLoading] = React.useState(false);
  const { showSuccessToast, showErrorToast, showDeleteToast } = useToast();
  const from = location.state?.from;
  const countryCode = COMMON_UTIL.getCountryCodeFromLanguage(
    languageStore.language
  );

  // 연결 완료 후 다음 액션을 onSetDeviceId에서 처리하기 위한 보관값
  // 1: wifi세팅 2: 언어세팅 3: 기기추가(토스트만)
  const pendingModeRef = React.useRef(0);

  // globalPenStatus를 Ref로 추적 (클로저 문제 해결)
  const globalPenStatusRef = React.useRef(globalPenStatus);

  const handleBack = () => {
    if (location.state?.from === "setting") {
      history.goBack(); // Setting 페이지로 돌아가기
    } else {
      history.push("/home");
    }
  };

  //1:wifi세팅 2:언어세팅 3:기기추가
  const setModeRef = React.useRef(0);
  const handleWifiSettingClick = () => {
    console.log("PokoroSetting handleWifiSettingClick");
    // 펜이 연결되어 있는지 확인
    if (globalPenStatus.isConnect) {
      // 연결되어 있으면 바로 Wi-Fi 설정 페이지로 이동
      history.push({
        pathname: "/wifiConnect",
        search: "?connectByPokoroSetting=false",
        state: { from: "pokoroSetting" },
      });
    } else {
      setModeRef.current = 1;
      pendingModeRef.current = 1;
      connectPokoro();
      // 연결되어 있지 않으면 연결 로딩 팝업 표시
      setShowConnectLoading(true);

    }
  };

  const handleCloseConnectLoading = () => {
    setShowConnectLoading(false);
    setModeRef.current = 0;
    stopScan();
  };

  const handleLanguageSettingClick = () => {
    // 펜이 연결되어 있는지 확인
    if (globalPenStatus.isConnect) {
      // 연결되어 있으면 바로 언어 설정 페이지로 이동
      history.push("/languageSetting?connectByPokoroSetting=false");
    } else {
      // 연결되어 있지 않으면 연결 로딩 팝업 표시
      setModeRef.current = 2;
      pendingModeRef.current = 2;
      connectPokoro();
      setShowConnectLoading(true);
    }
  };

  // let isConnectPokoro = false;

  const isConnectPokoroRef = React.useRef(false);

  const handleAddDevice = () => {
    setModeRef.current = 3;
    pendingModeRef.current = 3;
    connectPokoro();
    setShowConnectLoading(true);
  };


  let reqSetServer = false;
  let lang_system = "";




  const onDeviceConnecting = () => {
    console.log("=== onDeviceConnecting");
    // setLoading(true);
  };


  const onDeviceConnected = () => {
    // alert("=== onDeviceConnected");
    console.log(
      `onDeviceConnected setMode=${setModeRef.current}+lang_system ${lang_system}+countryCode ${countryCode}`
    );
    // Ref를 통해 최신 globalPenStatus 값 참조
    console.log("현재 globalPenStatus:", globalPenStatusRef.current);

    setShowConnectLoading(false);
    isConnectPokoroRef.current = true;

    if (lang_system !== countryCode) {
      console.log("=== onDeviceConnected reqSetLangAfterConnect");
      // setLangAfterConnect(true);
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo, // spread the previous deviceInfo object
          lang_system: countryCode, // update lang_main
        },
      }));

      const currentStatus = globalPenStatusRef.current;
      const settingData = {
        messageType: "POKORO2_Settings",
        payload: {
          lang_system: countryCode,
          lang_speaking: currentStatus.deviceInfo.lang_speaking,
          lang_listening_main: currentStatus.deviceInfo.lang_listening_main,
          lang_listening_sub: currentStatus.deviceInfo.lang_listening_sub,
        },
      };
      const lang_speaking = currentStatus.deviceInfo.lang_speaking;
      console.log(
        `customSendSetting globalPenStatus.deviceInfo.lang_system=${countryCode},lang_speaking=${lang_speaking}`
      );

      customSendSetting(JSON.stringify(settingData));
    }

    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: true,
    }));
    // 다음 라우팅/액션은 deviceId 수신(onSetDeviceId) 이후에 처리한다.
  };



  const onDeviceDisConnected = () => {
    // alert("=== onDeviceDisConnected");
    console.log("=== onDeviceDisConnected");
    isConnectPokoroRef.current = false;
    setShowConnectLoading(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
  };


  const onDeviceConnectFail = () => {
    console.log("=== onDeviceConnectFail");
    setShowConnectLoading(false);
    isConnectPokoroRef.current = false;
    showErrorToast(
      <span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "connectfail_dialog_Title" })}
      </span>
    );
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
  };


  const onPokoroStatus = (jsonStr) => {
    // alert(`=== onPokoroStatus: ${jsonStr}`);
    // setLoading(true);
    console.log(`=== onPokoroStatus: ${jsonStr.jsonStr}`);
    const status = JSON.parse(jsonStr.jsonStr);

    const serverList = JSON.parse(localStorage.getItem("_AGENT_SERVER_LIST_"));
    const Server = serverList.find(
      (server) => server.name === status.payload.serverInfo.name
    );
    const ServerUrl = Server ? Server.serverUrl : null;

    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      batteryPercentage: status.payload.batteryPercentage,
      storagePercentage: status.payload.storagePercentage,
      ConnectedAP1: status.payload.ConnectedAP1,
      ConnectedAP2: status.payload.ConnectedAP2,
      ConnectedAP3: status.payload.ConnectedAP3,
      deviceInfo: status.payload.deviceInfo,
      serverInfo: {
        ...prevStatus.serverInfo,
        name: status.payload.serverInfo.name,
        url: ServerUrl,
      },
      name: status.payload.deviceInfo.name,
    }));
    const settingData = {
      messageType: "POKORO2_Settings",
      payload: {
        server_name: status.payload.serverInfo.name,
        server_url: ServerUrl,
      },
    };
    reqSetServer = true;
    customSendSetting(JSON.stringify(settingData));

  };

  const onCustomSendResult = (jsonStr) => {
    const result = JSON.parse(jsonStr.jsonStr);
    console.log(`onCustomSendResult=${result}`);
    if (reqSetServer) {
      reqSetServer = false;
      const authData = {
        messageType: "POKORO2_Auth",
        payload: {
          token: localStorage.getItem("_NDP_ACCESS_TOKEN_"), // 동적으로 주어진 토큰 값
          refreshToken: localStorage.getItem("_NDP_REFRESH_TOKEN_"), // 동적으로 주어진 리프레시 토큰 값
        },
      };
      customSendToken(JSON.stringify(authData));
    }

  };


  // globalPenStatus 동기화 (클로저 문제 해결)
  useEffect(() => {
    globalPenStatusRef.current = globalPenStatus;
    isConnectPokoroRef.current = globalPenStatus.isConnect;
  }, [globalPenStatus]);

  // 이벤트 리스너 등록 (마운트 시 한 번만)
  useEffect(() => {
    console.log(
      `==========AppLanguageSetting useEffect isConnectPokoroRef== ${isConnectPokoroRef.current},globalPenStatus.isConnect=${globalPenStatus.isConnect} `
    );
    console.log(`Pokoro Setting useEffect from = ${location.state?.from}`);

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnecting,
      async (event) => {
        onDeviceConnecting();
      }
    );
    //NativeToJsEventOnDeviceConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnected,
      async (event) => {
        onDeviceConnected();
      }
    );

    //NativeToJsEventOnDeviceDisConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        onDeviceDisConnected();
      }
    );

    //NativeToJsEventOnDeviceConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnectFail,
      async (event) => {
        onDeviceConnectFail();
      }
    );

    //NativeToJsEventOnPokoroStatus
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onPokoroStatus,
      async (event) => {
        const jsonStr = event;
        onPokoroStatus(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        onCustomSendResult(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onSetDeviceId,
      async (event) => {
        const deviceId = event.deviceId;
        const userId = authStore.loginUser?.id;
        if (!userId) {
          console.warn("[PokoroSetting] onSetDeviceId ignored: missing userId");
          return;
        }

        const mode = pendingModeRef.current || setModeRef.current;
        const next = (() => {
          if (mode === 1) {
            return {
              pathname: "/wifiConnect",
              search: "?connectByPokoroSetting=true",
              state: { from: "pokoroSetting" },
              redirectUrl: "/wifiConnect?connectByPokoroSetting=true",
            };
          }
          if (mode === 2) {
            return {
              pathname: "/languageSetting",
              search: "?connectByPokoroSetting=true",
              state: undefined,
              redirectUrl: "/languageSetting?connectByPokoroSetting=true",
            };
          }
          return null; // mode 3: 라우팅 없음(토스트만)
        })();

        try {
          const hasLinkedProfile = await userStore.getUserDeviceProfileExists(
            userId,
            deviceId
          );
          const hasUnlinkedProfile =
            await userStore.getUnlinkedDeviceProfileExists(userId);

          // 프로필이 없는 상태에서는 user_connected_devices에 저장하지 않는다.
          // 또한 프로필 설정 화면으로 이동해야 하는 케이스:
          // - (userId, deviceId) 프로필이 없고
          // - (userId, '') 프로필도 없을 때만
          if (!hasLinkedProfile && !hasUnlinkedProfile) {
            authStore.initProfileInfo();
            history.push("/signin/profile-registration-prompt", {
              notNewUser: true,
              redirectUrl:
                next?.redirectUrl ?? "/pokoroConnect?hideSkipButton=true",
              deviceId,
              showBackButton: false,
              returnToPokoroSettingAfterProfile: true,
            });
            pendingModeRef.current = 0;
            setModeRef.current = 0;
            return;
          }

          // 프로필이 있을 때만 user_connected_devices upsert
          userStore.updateConnectedDevice(userId, deviceId, () => {
            userStore.getUserDeviceList(userId, true);
          });

          // 기존 동작 유지
          if (mode === 3) {
            showSuccessToast(
              <span style={{ whiteSpace: "pre-line" }}>
                {intl.formatMessage({ id: "connect_complete_toast" })}
              </span>
            );
          } else if (next) {
            history.push({
              pathname: next.pathname,
              search: next.search,
              state: next.state,
            });
          }
        } catch (e) {
          console.error("[PokoroSetting] post-connect check failed:", e);
          // 실패 시에는 기존 흐름으로 진행(가능한 경우에만)
          if (mode === 3) {
            showSuccessToast(
              <span style={{ whiteSpace: "pre-line" }}>
                {intl.formatMessage({ id: "connect_complete_toast" })}
              </span>
            );
          } else if (next) {
            history.push({
              pathname: next.pathname,
              search: next.search,
              state: next.state,
            });
          }
        } finally {
          pendingModeRef.current = 0;
          setModeRef.current = 0;
        }
      }
    );


    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnecting
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnectFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onPokoroStatus
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onSetDeviceId
      );

    };

  }, []);

  return (
    <>
      <Stack width='100%'>
        <TitleBox
          title={intl.formatMessage({ id: "device_settings" })} /* 포코로 설정 */
          subtitle={intl.formatMessage({ id: "pokoro_setting_text" })} /* 포코로의 설정을 관리할 수 있어요. */
          onBack={handleBack}
        />

        <ContentsBox className="setting-box">
          {/*펜 연결 이력이 있을때*/}
          <ListBox sx={{ gap: 0 }}>
            <StyledLinkButton onClick={handleWifiSettingClick}>
              {intl.formatMessage({ id: "wifi_settings" })} {/* WI-FI 설정 */}
              <Icon icon="weui:arrow-outlined" fontSize={20} />
            </StyledLinkButton>
            <StyledLinkButton onClick={handleLanguageSettingClick}>
              {intl.formatMessage({ id: "language_settings" })}{/* 언어설정 */}
              <Icon icon="weui:arrow-outlined" fontSize={20} />
            </StyledLinkButton>
          </ListBox>

          {/*펜 연결 이력이 없을때*/}
          {/*<ListBox>*/}
          {/*  <Stack gap={2} py={3} alignItems="center">*/}
          {/*    <img src={UnpokoroSetting} alt="Un_pokoro_setting"/>*/}
          {/*    <Typography variant="body1" textAlign="center" style={{ whiteSpace: "pre-line" }}>*/}
          {/*      {intl.formatMessage({ id: "unPokoro_setting_text" })} /!* 포코로를 연결하면\n학습 현황을 앱에서 확인할 수 있어요. *!/*/}
          {/*    </Typography>*/}
          {/*  </Stack>*/}
          {/*  <CommonButton*/}
          {/*      text={*/}
          {/*        intl.formatMessage({ id: "add_pokoro_device" })*/}
          {/*      }*/}
          {/*      background={c.bg}*/}
          {/*      border={c.grayHard}*/}
          {/*      color={c.text02}*/}
          {/*      icon={<AddIcon />}*/}
          {/*      iconPosition="left"*/}
          {/*      onClick={handleAddDevice}*/}
          {/*  />*/}
          {/*</ListBox>*/}

        </ContentsBox>
      </Stack>
      {/* 펜 연결 로딩 팝업 */}
      {showConnectLoading && (
        <PokoroConnectLoading
          text={intl.formatMessage({ id: "connecting_pokoro" })}
          onClose={handleCloseConnectLoading}
        />
      )}
    </>
  );
}

export default injectIntl(inject('languageStore', 'userStore', 'authStore')(observer(PokoroSetting)));
